// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_bugsnag_js_browser_notifier_js-node_modules_bugsnag_plugin-react_dist_bu-48ff7d"], () => (__webpack_require__("./src/web/client/src/client.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
